import React from 'react';

/**
 * Ista fotografija kao početna hero, blurovana + teget overlay.
 * Koristi unutar sekcije sa `relative overflow-hidden bg-primary` — sadržaj neka bude `relative z-10`.
 */
export function PrimarySectionBackdrop() {
  const base = process.env.PUBLIC_URL || '';
  return (
    <div className="pointer-events-none absolute inset-0" aria-hidden>
      <img
        src={`${base}/hero.png`}
        alt=""
        className="h-full w-full scale-110 object-cover blur-md sm:blur-lg"
      />
      <div className="absolute inset-0 bg-gradient-to-br from-primary via-primary/92 to-primary/88" />
      <div className="absolute inset-0 opacity-[0.12]">
        <div className="absolute right-0 top-0 h-80 w-80 rounded-full bg-cool blur-3xl" />
        <div className="absolute bottom-0 left-0 h-80 w-80 rounded-full bg-heat blur-3xl" />
      </div>
    </div>
  );
}
